/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-file-document-import': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M17.5 11.875H9.269l1.612-1.619L10 9.375 6.875 12.5 10 15.625l.881-.881-1.612-1.619H17.5v-1.25zM15 8.75v-2.5a.625.625 0 00-.181-.444l-4.375-4.375A.625.625 0 0010 1.25H3.75c-.69 0-1.25.56-1.25 1.25v15c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25v-1.25h-1.25v1.25h-10v-15h5v3.75c0 .69.56 1.25 1.25 1.25h3.75v1.25H15zm-5-2.5V2.756l3.494 3.494H10z"/>'
  }
})
